import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconCalendarLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.308 20.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 0 1-.525-1.283V7.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h1.384V4.154c0-.22.074-.402.22-.55a.746.746 0 0 1 .55-.22.749.749 0 0 1 .769.77V5.5h7.577V4.135a.73.73 0 0 1 .215-.535.727.727 0 0 1 .535-.215c.213 0 .39.072.534.215a.726.726 0 0 1 .216.535V5.5h1.384c.505 0 .933.175 1.283.525.35.35.525.778.525 1.283v11.384c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H5.308Zm0-1.5h13.384a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.212v-7.384H5v7.384c0 .077.032.148.096.212a.294.294 0 0 0 .212.096ZM5 9.808h14v-2.5a.294.294 0 0 0-.096-.212.294.294 0 0 0-.212-.096H5.308a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212v2.5Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconCalendarLine;
